import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=17630de2&"
import script from "./CommentItem.vue?vue&type=script&lang=js&"
export * from "./CommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17630de2')) {
      api.createRecord('17630de2', component.options)
    } else {
      api.reload('17630de2', component.options)
    }
    module.hot.accept("./CommentItem.vue?vue&type=template&id=17630de2&", function () {
      api.rerender('17630de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/CommentItem.vue"
export default component.exports